import styled from 'styled-components';
import { Outlet } from 'react-router-dom';

import { useModal } from 'hooks/modalContext';

/* 컴포넌트 */
import CustomerNavigation from '../components/customer/CustomerNav';

import ImgDetailModal from '../components/customer/ImgDetailModal';

import React from 'react';
export default function CustomerLayout() {

  const { modalType, isModalOpen, closeModal, props } = useModal();

  const renderModalContent = () => {
    switch (modalType) {
      case 'ImgDetail':
        return <ImgDetailModal props={props}/>;
      default:
        return null;
    }
  };
  return (
    <>
       {/* 메인 컨텐츠 */}
      <ContentWrap>
        <ContentBox>
          <Outlet/>
        </ContentBox>
        {/*<CustomerNavigation />*/}
      </ContentWrap>

      {/* 모달 영역 */}
      {isModalOpen && (
        <Modal>
          <ModalWrapper>{renderModalContent()}</ModalWrapper>
          <Dimmed onClick={closeModal}/>
        </Modal>
      )}
    </>
  );
};

const ContentWrap = styled.div`
  & * {
    font-family: 'Apple SD Gothic Neo', serif;
  }
`;

const ContentBox = styled.div`
  position: relative;
`;

const Modal = styled.div`
  & * {
    font-family: 'Apple SD Gothic Neo', serif;
  }
  
  z-index:99;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`;

const ModalWrapper = styled.div`
  z-index: 2;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  .close-modal-btn {
    z-index: 99;
    position: absolute;
    top: 20px;
    right: 20px;
  }
`;

const Dimmed = styled.div`
  z-index: 1;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
`;